<table border="1" *ngIf="dataSource && full">
    <tr class="header-row">
        <td colspan="4" align="center"><b>Действия</b></td>
        <td class="header" *ngFor="let field of full | keyvalue:defaultOrder"><b>{{ field.value.name }}</b></td>
    </tr>
    <tr class="header-row">
        <td (click)="search()" class="borderless">
            <div>
                <i class="fas fa-search"></i>
            </div>
        </td>
        <td (click)="create()" class="borderless">
            <div>
                <i class="fas fa-plus-square"></i>
            </div>
        </td>
        <td class="borderless">
        </td>
        <td (click)="clear()" class="borderless">
            <div>
                <i class="fas fa-backspace"></i>
            </div>
        </td>

        <td *ngFor="let field of full | keyvalue:defaultOrder" [ngSwitch]="field.value.type" class="header">
<!--            <ng-container *ngIf="field.value.type.split(':')[0] == 'readonly'">-->
<!--                <i>readonly</i>-->
<!--            </ng-container>-->
<!--            <ng-container *ngIf="field.value.type.split(':')[0] != 'readonly'">-->
                <select *ngSwitchCase="'enum'" (change)="changeSelect(field.key, $event.target.value)" value="0">
                    <option *ngFor="let item of field.value.enum | keyvalue:defaultOrder"
                            [value]="item.key">{{ item.value }}</option>
                </select>
                <ng-container *ngSwitchCase="'file:Image'">
                    <input type="file" (change)="fileChanged(field.key, new_model, $event.target.files)">
                </ng-container>
                <textarea *ngSwitchCase="'text'" [(ngModel)]="new_model[field.key]" placeholder="{{ field.value.name }}"
                          rows="1"></textarea>
                <textarea *ngSwitchCase="'string'" [(ngModel)]="new_model[field.key]" placeholder="{{ field.value.name }}"
                      rows="1"></textarea>
                <div *ngSwitchCase="'datetime'" style="display: flex; justify-content: space-between">
                    <input [(ngModel)]="new_model[field.key]" placeholder="{{ field.value.name }}">
                    <button [(datePicker)]="new_model[field.key]">
                        <i class="fas fa-calendar-day"></i>
                    </button>
                </div>
                <span *ngSwitchCase="'readonly'"><i>readonly</i></span>
                <div *ngSwitchDefault style="display: flex; justify-content: space-between">
                    <input [(ngModel)]="new_model[field.key]" [pattern]="pattern[field.value.type]"
                           placeholder="{{ field.value.name }}">
                    <button *ngIf="DATA.isRelation(field.value.type)"
                            (click)="showRelationTable(field.value.type, field.key, new_model)">
                        <i class="fas fa-th-list"></i>
                    </button>
                </div>
<!--            </ng-container>-->
        </td>
    </tr>
    <tr *ngFor="let row of dataSource; let i = index;"
        class="{{ rowStyle(i, row) }}"
        (dblclick)="set_edit(row)"
        >
        <td class="borderless">
            <div (click)="toggleRow(row)">
                <i class="far fa-{{ row.selected ? 'check-' : '' }}square"></i>
            </div>
        </td>
        <td class="borderless">
            <div (click)="copy(row, i)">
                <i class="far fa-copy"></i>
            </div>
        </td>
        <ng-container *ngIf="row.state == VIEW || !row.state">
            <td class="borderless">
                <div (click)="set_delete(row)">
                    <i class="fas fa-trash-alt"></i>
                </div>
            </td>
            <td class="borderless">
                <div (click)="set_edit(row)">
                    <i class="fas fa-pen"></i>
                </div>
            </td>
        </ng-container>
        <ng-container *ngIf="row.state == EDIT">
            <td class="borderless">
                <div (click)="apply_edit(row, i)">
                    <i class="fas fa-check"></i>
                </div>
            </td>
            <td class="borderless">
                <div (click)="cancel_edit(row)">
                    <i class="fas fa-times"></i>
                </div>
            </td>
        </ng-container>
        <ng-container *ngIf="row.state == DELETE">
            <td class="borderless">
                <div (click)="cancel_delete(row)">
                    <i class="fas fa-times"></i>
                </div>
            </td>
            <td class="borderless">
                <div (click)="apply_delete(row, i)">
                    <i class="fas fa-check"></i>
                </div>
            </td>
        </ng-container>
        <ng-container *ngIf="row.state != EDIT">
            <td *ngFor="let field of full | keyvalue:defaultOrder" [ngSwitch]="field.value.type">
                <ng-container *ngSwitchCase="'file:Image'">
                    <button *ngIf="row[field.key]" (click)="openPictureDialog(row[field.key])" style="padding: 0">
                        <img src="{{ url + row[field.key] }}">
                    </button>
                </ng-container>
                <div *ngSwitchCase="'enum'">{{ field.value.enum[row[field.key]] }}</div>
                <ng-container *ngSwitchDefault>
                    <!-- Ссылка на профиль -->
                    <!--                    <ng-container *ngIf="DATA.hasProfileLink(row, field.key, table, field.value.type)">-->
                    <!--                        <a href="/profile/{{ row[field.key] }}" target="_blank">-->
                    <!--                            <i class="fas fa-user"></i>-->
                    <!--                        </a>-->
                    <!--                    </ng-container>-->
                    <div class="td-relation" *ngIf="DATA.isRelation(field.value.type)">
                        <div class="left">
                            <button>ID: {{ row[field.key] }}</button>
                        </div>
                        <div>
                            {{ getName(row, field.key) }}
                        </div>
                    </div>

                    <ng-container *ngIf="!DATA.isRelation(field.value.type)">
                        {{ getName(row, field.key) }}
                    </ng-container>
                </ng-container>
            </td>
        </ng-container>
        <ng-container *ngIf="row.state == EDIT">
            <td *ngFor="let field of full | keyvalue:defaultOrder" [ngSwitch]="field.value.type"
                [ngClass]="{ 'td-rel': DATA.isRelation(field.value.type) }">
                <ng-container *ngIf="field.value.type.split(':')[0] == 'readonly'">
                    <!-- Ссылка на профиль -->
                    <!--                    <ng-container *ngIf="DATA.hasProfileLink(row, field.key, table, field.value.type)">-->
                    <!--                        <a href="/profile/{{ row[field.key] }}" target="_blank">-->
                    <!--                            <i class="fas fa-user"></i>-->
                    <!--                        </a>-->
                    <!--                    </ng-container>-->
                    <!-- -->
                    {{ getName(row, field.key) }}
                </ng-container>
                <ng-container *ngIf="field.value.type.split(':')[0] != 'readonly'">
                    <select *ngSwitchCase="'enum'" [(ngModel)]="row.backup[field.key]" [value]="row.backup[field.key]">
                        <option *ngFor="let item of field.value.enum | keyvalue:defaultOrder"
                                [value]="item.key">{{ item.value }}</option>
                    </select>
                    <textarea *ngSwitchCase="'text'" [(ngModel)]="row.backup[field.key]"
                              placeholder="{{ field.value.name }}"></textarea>
                    <textarea *ngSwitchCase="'string'" [(ngModel)]="row.backup[field.key]"
                              placeholder="{{ field.value.name }}"></textarea>
                    <ng-container *ngSwitchCase="'file:Image'">
                        <input type="file" (change)="fileChanged(field.key, row.backup, $event.target.files)">

                        <div>
                            <button *ngIf="row.backup['preview_' + field.key] || row[field.key]" (click)="openPictureDialog(row[field.key])" style="padding: 0">
                                <img src="{{ row.backup['preview_' + field.key] ? row.backup['preview_' + field.key] : (url + row[field.key]) }}">
                            </button>
                        </div>
                    </ng-container>
                    <div *ngSwitchCase="'datetime'" style="display: flex; justify-content: space-between">
                        <input [(ngModel)]="row.backup[field.key]" placeholder="{{ field.value.name }}">
                        <button [(datePicker)]="row.backup[field.key]">
                            <i class="fas fa-calendar-day"></i>
                        </button>
                    </div>
                    <span *ngSwitchCase="'readonly'">{{ row.backup[field.key] }}</span>
                    <div *ngSwitchDefault style="display: flex; justify-content: space-between">
                        <input *ngIf="row.backup && row.backup[field.key]" [(ngModel)]="row.backup[field.key]" placeholder="{{ field?.value?.name }}" [readOnly]="field.key == primaryKey">
                        <button *ngIf="DATA.isRelation(field.value.type)"
                                (click)="showRelationTable(field.value.type, field.key, row.backup)">
                            <i class="fas fa-th-list"></i>
                        </button>
                    </div>
                </ng-container>
            </td>
        </ng-container>
    </tr>
</table>



<app-relation [table]="relation_model" (onChangeId)="onChangeId($event)" (onClose)="showRelation = false"
              *ngIf="showRelation"></app-relation>
